const Items = [
  {
    icon: "fa-solid fa-users",
    title: "Competitive Rates",
    text:
      "Our rates are highly competitive, ensuring you receive excellent value for your money. With us, you can be confident that you are getting the best possible pricing without compromising on engineering quality, security, or support.",
  },
  {
    icon: "fa-solid fa-award",
    title: "Quality",
    text:
      "We take pride in delivering exceptional results. Rigorous QA, automated testing, code reviews, and modern best practices ensure a polished, high‑quality product every single time.",
  },
  {
    icon: "fa-solid fa-building-user",
    title: "In‑House Expertise",
    text:
      "Our 1000+ designers, developers, and project managers are directly employed by us and work in our own offices across the US, UK, India, and globally. This ensures seamless collaboration, consistent quality, and full control over your project.",
  },
  {
    icon: "fa-solid fa-shield-halved",
    title: "Security & Confidentiality",
    text:
      "Your IP remains yours—always. We follow strict security policies, access controls, and NDAs as required, ensuring your data, code, and business intelligence stay protected and confidential.",
  },
  {
    icon: "fa-solid fa-stopwatch",
    title: "On‑Time Delivery",
    text:
      "We use cutting‑edge project management tools, Agile processes, and CI/CD to keep your project on track. This means you’ll get high‑quality deliverables exactly when you expect them.",
  },
  {
    icon: "fa-solid fa-handshake",
    title: "Flexible Engagement Models",
    text:
      "We understand your needs can change. Choose the model that works best for you now—fixed scope, T&M, or dedicated teams—and switch seamlessly as your priorities evolve.",
  },
];

export default Items;